"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _reactBootstrap = require("react-bootstrap");

var _ = require("../../");

var _auth = require("../../../redux/modules/auth");

var _popup = require("../../../redux/modules/popup");

var _DefaultString = require("../../../helpers/DefaultString");

var _FormatTvCodeError = require("../../../helpers/FormatTvCodeError");

var _ValidateTvCode = require("../../../helpers/ValidateTvCode");

var _Cookie = require("../../../helpers/Cookie");

var _TvCodeExpiryPopup = require("./TvCodeExpiryPopup.scss");

var _TvCodeExpiryPopup2 = _interopRequireDefault(_TvCodeExpiryPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TvCodeExpiryPopup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
}, {
  closePopup: _popup.closePopup,
  tvFlowStarted: _auth.tvFlowStarted
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TvCodeExpiryPopup, _Component);

  function TvCodeExpiryPopup(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, TvCodeExpiryPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TvCodeExpiryPopup.__proto__ || (0, _getPrototypeOf2.default)(TvCodeExpiryPopup)).call(this, props));

    _this.handleCodeChange = function (input) {
      if (input.length <= 4) {
        var processedInput = input.toUpperCase().replace(/[^a-z0-9]/gi, "").trim();
        _this.setState((0, _extends3.default)({}, _this.state, { tvCode: processedInput, error: null }));
      }
    };

    _this.handleFormSubmit = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var inputtedCode, response, tvCode, tvData, error, clientId, remainingTime, errorResponse;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.state.tvCode.length !== 4)) {
                _context.next = 3;
                break;
              }

              _this.setState((0, _extends3.default)({}, _this.state, {
                error: "INVALID_CODE",
                loading: false
              }));
              return _context.abrupt("return");

            case 3:
              _context.prev = 3;

              _this.setState((0, _extends3.default)({}, _this.state, { loading: true }));
              inputtedCode = _this.state.tvCode;
              _context.next = 8;
              return (0, _ValidateTvCode.validateTvCode)(inputtedCode);

            case 8:
              response = _context.sent;

              if (!response) {
                _context.next = 22;
                break;
              }

              tvCode = response.tvCode, tvData = response.tvData, error = response.error;

              if (error) {
                _context.next = 19;
                break;
              }

              clientId = tvData.clientId, remainingTime = tvData.remainingTime;

              _this.props.tvFlowStarted(tvCode, clientId);
              sessionStorage.setItem(_Cookie.tvCodeSessionStorageName, tvCode);
              sessionStorage.setItem(_Cookie.tvCodeExpirySessionStorageName, Date.now() + remainingTime);
              _this.props.closePopup();
              _context.next = 20;
              break;

            case 19:
              throw new Error(error);

            case 20:
              _context.next = 23;
              break;

            case 22:
              throw new Error("NO_RESPONSE");

            case 23:
              _context.next = 28;
              break;

            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](3);

              if (_context.t0.response.data.error) {
                errorResponse = _context.t0.response.data.error;

                console.error(errorResponse);
                _this.setState((0, _extends3.default)({}, _this.state, { loading: false, error: errorResponse }));
              } else {
                console.error(_context.t0);
                _this.setState((0, _extends3.default)({}, _this.state, { loading: false, error: _context.t0 }));
              }

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[3, 25]]);
    }));

    _this.handleKeyPress = function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        _this.handleFormSubmit();
      }
    };

    _this.handleButtonClicked = function () {
      _this.handleFormSubmit();
    };

    _this.state = { tvCode: "", loading: false, error: null };
    return _this;
  }

  (0, _createClass3.default)(TvCodeExpiryPopup, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        "div",
        { className: _TvCodeExpiryPopup2.default.content },
        _react2.default.createElement(
          "div",
          { className: _TvCodeExpiryPopup2.default.title },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.TVCodeExpiryPopupTitle)
        ),
        _react2.default.createElement(
          "div",
          { className: _TvCodeExpiryPopup2.default.message },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.TVCodeExpiryPopupSubtitle)
        ),
        this.state.error && _react2.default.createElement(
          "div",
          { className: _TvCodeExpiryPopup2.default.errorMessage },
          (0, _FormatTvCodeError.formatTvCodeError)(this.state.error)
        ),
        _react2.default.createElement(_reactBootstrap.FormControl, {
          className: _TvCodeExpiryPopup2.default.textInput,
          name: "code",
          type: "text",
          value: this.state.tvCode,
          onChange: function onChange(e) {
            _this3.handleCodeChange(e.target.value);
          },
          onKeyPress: function onKeyPress(e) {
            _this3.handleKeyPress(e);
          }
        }),
        _react2.default.createElement(_.BaseButton, {
          onClick: this.handleButtonClicked,
          buttonString: _DefaultString.translations.TVCodeExpiryPopupCTA,
          className: _TvCodeExpiryPopup2.default.okButton
        })
      );
    }
  }]);
  return TvCodeExpiryPopup;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  closePopup: _react.PropTypes.func,
  tvFlowStarted: _react.PropTypes.func
}, _temp)) || _class);
exports.default = TvCodeExpiryPopup;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/TvCodeExpiryPopup/TvCodeExpiryPopup.js
// module id = 1979
// module chunks = 0